module.exports = __webpack_public_path__ + "media/images/pc/top/area_brand_sola@3x-c73d7e8375c6f999df97fb776b969c60.webp";